// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "bc9a8e28e7c86b67","191": "293570ac066f48f6","396": "ebfbb1ffb04d48a6","460": "be1cfea0a619f70d","498": "4b4200a1b74a67c8","917": "a088a8f8033997a2","985": "9b7e3c7679d8f3e4",}[chunkId] + ".chunk.js"
}